<template>
    <v-card>
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
            Bulk Edit {{ samples.length }} Samples
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <v-form @submit.prevent="applyEdits" v-model="isFormValid" ref="form">
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="sampleDescriptor"
                            label="Sample Descriptor"
                            :items="sampleDescriptors"
                            item-title="name"
                            item-value="id"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-date-input
                            v-model="collectionDate"
                            label="Collection Date"
                            :min="new Date().toISOString().substring(0, 10)"
                            :max="
                                new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                                    .toISOString()
                                    .substring(0, 10)
                            "
                        ></v-date-input>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel" color="primary">Cancel</v-btn>
            <v-btn @click="applyEdits" color="primary" :disabled="!isFormValid">Apply</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import { MaterialSample, SampleDescriptor } from "@/services/samples/samplesAPI";
import { ref } from "vue";

const { samples, sampleDescriptors } = defineProps<{
    samples: MaterialSample[];
    sampleDescriptors: SampleDescriptor[];
}>();

const emit = defineEmits<{
    (e: "canceled"): void;
    (
        e: "samplesBulkEdited",
        values: {
            descriptor: string | null;
            collectionDate: Date | null;
        }
    ): void;
}>();

const sampleDescriptor = ref<string | null>(null);
const collectionDate = ref<Date | null>(null);
const isFormValid = ref(false);

function cancel() {
    emit("canceled");
}

function applyEdits() {
    emit("samplesBulkEdited", {
        descriptor: sampleDescriptor.value,
        collectionDate: collectionDate.value,
    });
}
</script>
